// more voice options?
export enum VoiceOptions {
  femaleEnglishUS = 'female/en-US',
  maleEnglishUS = 'male/en-US',
}
